import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'
import type { MarketExceptionType } from '../MarketExceptionTypes'
import { internalMarketExceptions as marketExceptions } from '../MarketExceptions'

export function getMarketConfig(
  countryCode: SupportedAlpha2CountryCode,
): MarketExceptionType {
  return marketExceptions[countryCode]
}
